import React from 'react';
import classnames from 'classnames';
import TabPanel from './tabPanel';
import './style.scss';

const prefixCls = 'tabs-container';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selected: props.defaultSelected };
    this.domRef = React.createRef();
  }

  static defaultProps = {
    titles: [],
    defaultSelected: 0,
    onChange: () => {},
    contentClass: '',
  };

  componentDidMount() {
    setTimeout(() => {
      this.domRef.current.scrollIntoViewIfNeeded();
    }, 100);
  }

  jumpToTab = (index) => {
    this.setState({ selected: index });
  }

  onChange = (index, title) => {
    if (
      index === this.state.selected
        || title.disabled
    ) {
      return;
    }

    this.setState({ selected: index });
    this.props.handleTrackingData(title);
  }

  render() {
    const { contentClass } = this.props;
    return (
      <div className={prefixCls}>
        <ul className="tabs-title">
          {
            this.props.titles.map((title, index) => {
              const props = {
                className: classnames({
                  'selected': index === this.state.selected,
                  'disabled': title.disabled,
                }),
                onClick: () => this.onChange(index, title),
              };
              // 默认tab到可见区域
              if (index === this.state.selected) {
                props.ref = this.domRef;
              }
              return (
                <li key={index} {...props}>
                  <span>{title.name}</span>
                </li>
              );
            })
          }
        </ul>
        <div className={`tabs-content ${contentClass}`}>
          {
            React.Children.map(this.props.children, (child, index) => {
              const show = index === this.state.selected;
              let style = {};
              if (!show) {
                style = { position: 'absolute', left: -9999 };
              }
              return <div style={style}>{child}</div>;
            })
          }
        </div>
      </div>
    );
  }
}

export { Tabs, TabPanel };
